import { HousingMarketResponse } from '@libs/types/generated/housing-market-ui'

export class DataProcessor {
  public constructor(public data: HousingMarketResponse) {}

  public metricsByPropertyType(type: string) {
    const metrics = this.data.property_types.find(t => t.type === type)
    return metrics
  }
}
